import { render } from "./Edit.vue?vue&type=template&id=280caef9&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=280caef9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-280caef9"

export default script